import { DateTime } from 'luxon';
import { PartyModel, PartyType } from 'models/PartyModel';
import { VoyageModel } from 'models/VoyageModel';
import { InvoiceSimpleModel } from 'models/InvoiceModel';
import { TransportationModel } from 'models/TransportationModel';
import { Point } from 'models/YardModel';
import { BLSimpleModel } from 'models/BLModel';


export enum StockStatus {
    Pending = 'pending',
    Ready = 'ready',
    Shipped = 'shipped',
    Received = 'received',
    Canceled = 'canceled',
    Lost = 'lost',
}

export enum ExportType {
    Car = 'car',
    DisCar = 'dis_car',
    CutFCar = 'cut_f_car',
    CutRCar = 'cut_r_car',
    Parts = 'parts',
}

export enum ExportMethod {
    Ship = 'ship',
    Container = 'container',
    Pallet = 'pallet',
}

export enum VehicleType {
    Sedan = 'sedan',
    Van = 'van',
    StationWagon = 'station wagon',
    Bus = 'bus',
    Truck = 'truck',
    Bike = 'bike',
    SpecialEquipment = 'special equipment',
    Excavator = 'excavator',
    Tractor = 'tractor',
    Roller = 'roller',
    Crane = 'crane',
    Boat = 'boat',
    KeiCar = 'kei car',
    Wagon = 'wagon',
    Forklift = 'forklift',
}

export enum FuelType {
    Gasoline = 'G',
    Diesel = 'D',
    HybridVehicle = 'HV',
    ElectricVehicle = 'EV',
    PropaneGas = 'LPG',
    FuelCellVehicle = 'FCV',
}

export enum PriceTerms {
    CAF = 'C&F',
    //CIF = 'CIF',
    FOB = 'FOB',
}

export type ExportCertificate = {
    referenceNum: string,
    validUntil?: string,
    originalSentAt?: string
    originalArrivedAt?: string
    originalConfirmedBy?: UserSimple,
    trackCode?: string
    courier?: string
}

export type StockData = {
    companyId?: number, // for agent who add car for lazy shipper
    yardId?: number,
    exportMethod?: ExportMethod,
    unitPrice?: number,
    priceTerms?: PriceTerms,
    grossWeight?: number,
    netWeight?: number,
    length?: number,
    width?: number,
    height?: number,
}

export type StockModel = StockData & {
    id: number,
    company: SimpleView,
    status: StockStatus,
    yard?: CarYard,
    prices?: {
        main: {
            id: number,
            total: number,
            paid: number,
            invoice: InvoiceSimpleModel
        },
        secondary: {
            id: number,
            total: number,
            paid: number,
            invoice: InvoiceSimpleModel
        },
        meta?: any,
    },
    invoices: InvoiceSimpleModel[],
    voyage?: VoyageModel,
    parties: { [key in PartyType]: PartyModel },
    partiesFilled: number,
    note: string,
    albums: {
        name: string,
        count: number,
        note: string,
    }[],
    photoCount: number,
}

export type CarData = StockData & {
    chassisNumber: string,
    exportType?: ExportType,
    make: string,
    model: string,
    year?: number,
    color?: string,
    vehicleType?: VehicleType,
    fuel?: FuelType,
    engineModel?: string,
    engineNumber?: string,
    engineSize?: number,
    enginePower?: number,
    seats?: number,
    cargoCapacity?: number,
    damaged?: boolean,
}

export type CarModel = StockModel & CarData & {
    innerCargo: InnerCargo[],

    yards: CarYard[],
    destinationYard: CarYard,

    exportCertificate: ExportCertificate,
    documents: {
        exportCertificate?: string,
        priceConfirmation?: string,
        vehicleInvoice?: string,
        vehicleCatalog?: string,
        explanatoryNote?: string,
        repairEstimate?: string,
    }

    shipDateLimit?: {
        after: boolean,
        date: string,
    },
    jpInvoice: {
        package?: number,
        batch: number,
        pos: number,
    }

    bls: BLSimpleModel[],

    url?: string, // query holder for virtual list
    transportations: TransportationModel[],
    tallyNumber: number,
    updatedAt: string,

    //fake fields for car card in ec preview mode
    referenceNum?: string,
    validUntil?: DateTime | null | string,
}

export type InnerCargo = {
    id: number,
    name: string,
    quantity: number,
    description: string,
    weight: number,
    price: number,
}

export type SimpleView = {
    id: number,
    name: string,
    phone: string,
    email: string,
}

export type CarYard = {
    id: number,
    name: string,
    address: string,
    port: string,
    portId: number,
    pivotId: number,
    dateIn: string,
    dateOut: string,
    key: string,
    location: string,
    arrived: boolean,
    coordinates: Point,
    instructions: boolean,
    capacity: number,
    occupied: number,
}

type UserSimple = {
    id: string,
    name: string,
}
